import type { LegacyCampaignInventoryResponseType } from 'features/CampaignAndDiscount/@types/legacyCampaignManual'
import type { AxiosResponse } from 'axios'
import type {
  LegacyCampaignAdjustmentType,
  LegacyCampaignCategoryType,
} from 'features/CampaignAndDiscount/@types/legacyCampaign'
// Fix this file, do not use any as the type
/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable @typescript-eslint/no-explicit-any */
import axios from 'axios'

const { REACT_APP_BASE_URL_API, REACT_APP_BASE_URL_KONG_API } = process.env
const baseUrl = REACT_APP_BASE_URL_API
const kongUrl = REACT_APP_BASE_URL_KONG_API

export const getCampaign_CAMPAIGN = (query: any): any =>
  axios.get(`${baseUrl}/api/campaigns${query}`)

export const putUpdateActivateCampaign_CAMPAIGN = (
  campaign_id: number | undefined,
  data: { is_active: boolean } | undefined,
): Promise<AxiosResponse<unknown>> =>
  axios.put(`${baseUrl}/api/campaign/${campaign_id}/active`, data)

export const deleteCampaign_CAMPAIGN = (
  data: (number | undefined)[],
): Promise<AxiosResponse<unknown>> => axios.delete(`${baseUrl}/api/campaign`, { data })

export const putAdjustCampaign_CAMPAIGN = (
  campaign_id: number | undefined,
  data: LegacyCampaignAdjustmentType | undefined,
): Promise<AxiosResponse<unknown>> =>
  axios.put(`${baseUrl}/api/campaign/${campaign_id}/edit-inventory`, data)

export const getCampaign_CAMPAIGN_ADD = (campaign_id: any, query: any): any =>
  axios.get(`${kongUrl}/campaign/internal/v1/${campaign_id}${query}`)

export const putUpdateDataCampaign_CAMPAIGN_ADD = (campaign_id: any, data: any, config: any): any =>
  axios.put(`${kongUrl}/campaign/internal/v1/${campaign_id}`, data, config)

export const postBulkUploadCampaign_CAMPAIGN_ADD = (
  campaign_id: any,
  data: any,
  config: any,
): any => axios.post(`${baseUrl}/api/v2/campaign/upload/${campaign_id}`, data, config)

export const postCreateCampaign_CAMPAIGN_ADD = (data: any): any =>
  axios.post(`${kongUrl}/campaign/internal/v1/create`, data)

export const postRemoveCampaign_CAMPAIGN_ADD = (campaign_id: any, data: any): any =>
  axios.post(`${baseUrl}/api/campaign/${campaign_id}/remove-inventory`, data)

export const deleteRemoveInventoriesCampaign_CAMPAIGN_ADD = (campaign_id: any, data: any): any =>
  axios.delete(`${baseUrl}/api/campaign/${campaign_id}/remove-inventory`, {
    data,
  })

export const putUpdateDataInventoriesPerItem_CAMPAIGN_ADD = (
  campaignInvetoryId: any,
  data: any,
): any => axios.put(`${baseUrl}/api/campaign/inventory/${campaignInvetoryId}`, data)

export const getBulkUploadInventoriesCampaign_CAMPAIGN_ADD = ({ params }: any): any =>
  axios.get(`${baseUrl}/api/campaign/inventory/csv/template`, { params })

export const getInventoryCampaign_CAMPAIGN_ADD = (campaign_id: any, query: any): any =>
  axios.get(`${baseUrl}/api/campaign/${campaign_id}/inventory${query}`)

export const putEditAllCampaign_CAMPAIGN_ADD = (
  campaign_id: number | undefined,
  data: LegacyCampaignAdjustmentType | undefined,
): Promise<AxiosResponse<unknown>> =>
  axios.put(`${baseUrl}/api/campaign/${campaign_id}/edit-inventory`, data)

export const getCampaign_CAMPAIGN_ADD_MANUAL = (
  query = '',
): Promise<AxiosResponse<LegacyCampaignInventoryResponseType>> =>
  axios.get(`${baseUrl}/api/inventories/v4${query}`)

export const getHubLocations_CAMPAIGN_ADD_MANUAL = (): any =>
  axios.get(`${baseUrl}/api/locations/hub`)

export const getCategories_CAMPAIGN_ADD_MANUAL = (): Promise<
  AxiosResponse<LegacyCampaignCategoryType[]>
> => axios.get(`${baseUrl}/api/categories/child`)

export const postAddManualInventoryCampaign_CAMPAIGN_ADD_MANUAL = (
  campaign_id: string | number | undefined,
  data: unknown,
): Promise<AxiosResponse<unknown>> =>
  axios.post(`${baseUrl}/api/campaign/${campaign_id}/add-inventory`, data)

export const getBulkUploadStatusCampaignProduct = (campaign_id: any): any =>
  axios.get(`${baseUrl}/api/campaign/${campaign_id}/progress`)
